const { handleError, handleResponse, api } = require("./baseApi");
const api_config = require("./api_config");

const EXTEND_URL = "/subscriptions/v1/";

function getSubscriptionApi(customerId) {
  return api
    .get(EXTEND_URL, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
      params: {
        customerId
      }
    })
    .then(handleResponse)
    .catch(handleError);
}


function getSubscriptionByEmailApi(email) {
  return api
    .get(EXTEND_URL, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
      params: {
        email
      }
    })
    .then(handleResponse)
    .catch(handleError);
}

function hasSubscriptionApi(email) {
  return api
    .head(EXTEND_URL, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
      params: {
        email
      }
    })
    .then(handleResponse)
    .catch(handleError);
}

function createSubscriptionApi(cusId, paymentMethodId, planId, merchantCode) {
  return api
    .post(
      `${EXTEND_URL}?customerId=${cusId}&paymentMethodId=${paymentMethodId}&planId=${planId}&merchantCode=${merchantCode}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      }
    )
    .then(handleResponse)
    .catch(handleError);
}

function createGuestSubscriptionApi(email, paymentMethodId, planId, merchantCode, preferredBasketCode) {
  const encodedEmail=encodeURIComponent(email);
  const preferredBasketCodeUrlParam = preferredBasketCode && preferredBasketCode.trim().length > 0 ? `&preferredBasketCode=${preferredBasketCode}` : '';
  return api
    .post(
      `${EXTEND_URL}?email=${encodedEmail}&paymentMethodId=${paymentMethodId}&planId=${planId}&merchantCode=${merchantCode}${preferredBasketCodeUrlParam}`,
      {
        headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
      }
    )
    .then(handleResponse)
    .catch(handleError);
}

function deleteSubscriptionApi(subId) {
  return api
    .delete(EXTEND_URL, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
      params: {
        subscriptionId: subId
      }
    })
    .then(handleResponse)
    .catch(handleError);
}

function createGroupSubscriptionApi(group) {
  return api
    .post(`${EXTEND_URL}group`, JSON.stringify(group), {
      headers: {
        "x-api-key": `${api_config.carbon_app_api_key}`
      }
    })
    .then(handleResponse)
    .catch(handleError);
}

function createFootprintSubscriptionApi(subscription) {
  return api
    .post(`${EXTEND_URL}footprint`, JSON.stringify(subscription), {
      headers: {
        "x-api-key": `${api_config.carbon_app_api_key}`
      }
    })
    .then(handleResponse)
    .catch(handleError);
}

function getFootprintSubscriptionByMerchantCodeApi(merchantCode) {
  return api
    .get(`${EXTEND_URL}footprint?merchantCode=${merchantCode}`, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
    })
    .then(handleResponse)
    .catch(handleError);
}

function updateSubscription(customerId, subscriptionId, paymentMethodId) {
    return api
        .patch(`${EXTEND_URL}${subscriptionId}`, JSON.stringify({paymentMethodId}), {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
            params:{ customerId }
        })
        .then(handleResponse)
        .catch(handleError);
}

function deleteFootPrintSubs(Id){
    return api
        .patch(`${EXTEND_URL}footprint/${Id}`, JSON.stringify({status:"CANCELLED"}),{
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }

        })
        .then(handleResponse)
        .catch(handleError);
}

function updateFootprintSubscriptionPaymentMethod(id, paymentMethod){
    return api
        .put(`${EXTEND_URL}footprint/${id}/payment-methods/current`, JSON.stringify(paymentMethod),{
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}

function updateGroupSubscriptionPaymentMethod(id, paymentMethod){
    return api
        .put(`${EXTEND_URL}group/${id}/payment-methods/current`, JSON.stringify(paymentMethod),{
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}

function deleteGroupSubs(Id){
    return api
        .patch(`${EXTEND_URL}group/${Id}`, JSON.stringify({status:"CANCELLED"}), {
            headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
        })
        .then(handleResponse)
        .catch(handleError);
}

module.exports = {
  getSubscriptionApi,
  getSubscriptionByEmailApi,
  createSubscriptionApi,
  createGuestSubscriptionApi,
  deleteSubscriptionApi,
  hasSubscriptionApi,
  createGroupSubscriptionApi,
  createFootprintSubscriptionApi,
  getFootprintSubscriptionByMerchantCodeApi,
  updateSubscription,
  deleteFootPrintSubs,
  deleteGroupSubs,
  updateGroupSubscriptionPaymentMethod,
  updateFootprintSubscriptionPaymentMethod
};
